<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div>
        <div class="select">
            <span class="name" v-if="name.length > 0">{{name}}</span>
            <div class="selected" v-on:click.self="toggle()">
                <label v-for="id in tempSelected" v-on:click.self="toggle()">
                    {{showLabel(id)}}
                </label>
                &nbsp;
            </div>
            <div class="detail" v-if="isOpened">
                <div class="search">
                    <input type="text" v-model="query" ref="input" placeholder="Ara" />
                </div>
                <div class="menu">
                    <a v-on:click="selectAll()" v-if="maxSelection > 1 || maxSelection == 0">Tümü</a>
                    <a v-on:click="selectNone()" v-if="minSelection == 0">Hiçbiri</a>
                </div>
                <div class="options_wrapper">
                    <div class="options">
                        <label v-for="row in getData()">
                            <input type="checkbox" :value="row.id" v-model="tempSelected" />
                            {{row.text}}
                        </label>
                    </div>
                </div>
                <div class="actions">
                    <a v-on:click="apply()" class="apply">Uygula</a>
                    <a v-on:click="cancel()" class="cancel">İptal</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import map from 'lodash.map';
    import includes from 'lodash.includes';
    import filter from 'lodash.filter';
    import toLower from 'lodash.tolower';
    import drop from 'lodash.drop';

    export default {
        props: {
            name: {
                type: String,
                default: '',
                required: false
            },
            data: {
                type: Array,
                required: true
            },
            maxSelection: {
                type: Number,
                default: 0,
                required: false
            },
            minSelection: {
                type: Number,
                default: 0,
                required: false
            },
            selected: {
                type: Array,
                required: true
            },
            searchable: {
                type: Boolean,
                required: false,
                default: false
            },
            remoteSearchable: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data: function () {
            return {
                isOpened: false,
                query: '',
                tempSelected: this.selected
            };
        },
        methods: {
            toggle: function () {
                this.isOpened = !this.isOpened;
            },
            getData: function () {
                var $this = this;
                if (this.searchable && this.query.length < 3) {
                    return filter(this.data, function (row) {return $this.selected.includes(row.id);});
                }
                return filter(this.data, function (row) {
                    // TODO: Chrome ve Safari üzerinde İ karakteri ile aramada sorun var.
                    return includes(toLower(row.text), toLower($this.query));
                });
            },
            selectAll: function () {
                var $this = this;
                this.tempSelected = [];
                map(this.data, function (row) {
                    $this.tempSelected.push(row.id);
                });
            },
            selectNone: function () {
                this.tempSelected = [];
            },
            apply: function () {
                this.isOpened = false;
                this.query = '';
                this.$emit('onChange', this.tempSelected);
            },
            cancel: function () {
                this.isOpened = false;
                this.query = '';
                this.tempSelected = this.selected;
            },
            showLabel: function (id) {
                return filter(this.data, function (row) {
                    return row.id === id;
                })[0].text;
            }
        },
        watch: {
            data: function () {
                this.selectNone();
            },
            tempSelected: function (newValue, oldValue) {
                if (this.maxSelection > 0 && newValue.length > this.maxSelection) {
                    this.tempSelected = drop(newValue);
                }
                if (this.minSelection > 0 && newValue.length < this.minSelection) {
                    this.tempSelected = oldValue;
                }
            },
            query: function (newValue) {
                if (this.remoteSearchable && newValue.length > 2) {
                    this.$emit('onQuery', newValue);
                }
            }
        },
        updated: function () {
            if (this.isOpened) {
                this.$refs.input.focus();
            }
        }
    }
</script>

<style scoped>
    * {
        font-family: Arial, Helvetica;
    }

    .select {
        position:relative;
        line-height: 20px;
    }

    .select .name {
        font-size: 12px;
    }

    .selected {
        background: #fff;
        border: 1px solid #ddd;
        display:block;
        cursor: pointer;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        padding: 4px;
        overflow: hidden;
        white-space:nowrap;
        text-overflow: clip;
    }

    .selected label {
        border-radius: 4px;
        font-size: 12px;
        background: #318FFD;
        color: #fff;
        padding: 3px;
        margin: 0;
        line-height: 12px;
        margin-right: 5px;
        cursor: pointer;
    }

    .detail {
        left: 0;
        right: 0;
        top: 20px;
        position: absolute;
        border: 1px solid #ccc;
        z-index: 10000;
    }

    /* Search Wrapper*/
    .search {
        padding: 4px;
        background: #ddd;
        border-bottom: 1px solid #ccc;
    }

    .search input{
        width: 100%;
        margin:0;
        border:0;
        padding:4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }

    .search input:focus
    {
        outline:0;
    }

    /* Options Menu */
    .menu {
        background: #ddd;
        padding: 4px;
    }

    .menu a {
        color: #3367d6;
        cursor: pointer;
        text-decoration: none;
        font-size: 12px;
    }

    .menu a:hover {
        text-decoration: underline;
    }

    /* Options */
    .options_wrapper{
        background: #fff;
        left: 0;
        right: 0;
        height: 150px;
        overflow: scroll;
        position: relative;
        border-bottom: 1px solid #ccc;
    }

    .options {
        display: block;
        padding: 8px;
    }

    .options label{
        display:block;
        cursor: pointer;
        margin-bottom: 4px;
    }

    /* Actions */
    .actions {
        background: #fff;
        padding: 16px 8px;
    }

    .actions a {
        padding: 8px;
        text-decoration: none;
        cursor: pointer;
    }

    .actions a.apply {
        background: #338DEF;
        color: #fff;
    }

    .actions a.cancel {
        background: #fff;
        color: #338DEF;
    }
</style>


// WEBPACK FOOTER //
// select.v2.vue?73f13af0